( function ( $ ) {
	if ( $( '.logos-slider__list' ).length ) {
		$( '.logos-slider__list' ).owlCarousel( {
			loop: true,
			margin: 0,
			nav: false,
			smartSpeed: 700,
			autoplay: true,
			autoplayTimeout: 3000,
			responsive: {
				0: {
					items: 2,
				},
				992: {
					items: 4,
				},
				1400: {
					items: 6,
				},
			},
		} );
	}
} )( jQuery );
